import { useCallback, useRef, type ForwardedRef, type RefCallback, type RefObject } from 'react';

export function useInterceptRef<T>(forwardedRef: ForwardedRef<T>): [RefObject<T | null>, RefCallback<T>] {
    const internalRef = useRef<T | null>(null);

    return [
        internalRef,
        useCallback(
            (el: T | null) => {
                internalRef.current = el;
                if (typeof forwardedRef === 'function') {
                    forwardedRef(el);
                } else if (forwardedRef) {
                    // eslint-disable-next-line react-hooks/immutability -- forwarded refs are designed to be mutated
                    forwardedRef.current = el;
                }
            },
            [forwardedRef],
        ),
    ];
}
